var _path, _g, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 102,
    viewBox: "0 0 101 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_17_283",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 101,
    height: 102
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.9299 101.731C78.5442 101.731 100.93 79.0863 100.93 51.1527C100.93 23.219 78.5442 0.574341 50.9299 0.574341C23.3157 0.574341 0.929932 23.219 0.929932 51.1527C0.929932 79.0863 23.3157 101.731 50.9299 101.731Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_17_283)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.9302 -2.15369C21.2332 -2.15369 -1.76679 19.8555 -1.76679 49.5588C-1.85772 56.7545 -0.42873 63.8869 2.42461 70.479C5.27795 77.071 9.48985 82.9708 14.7786 87.7838C15.2134 88.1667 15.5646 88.637 15.8098 89.1647C16.055 89.6925 16.1889 90.2661 16.2029 90.8491L16.4756 100.352C16.4931 101.067 16.687 101.766 17.0395 102.386C17.3921 103.005 17.8921 103.526 18.4943 103.901C19.0964 104.275 19.7816 104.492 20.4875 104.531C21.1934 104.569 21.8976 104.429 22.5362 104.122L32.8696 99.5241C33.7577 99.1312 34.7515 99.0556 35.6877 99.3095C40.6236 100.682 45.7203 101.373 50.8392 101.363C80.5059 101.363 103.536 79.3847 103.536 49.6814C103.536 19.9782 80.5968 -2.15369 50.9302 -2.15369Z",
    fill: "url(#paint0_radial_17_283)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.9302 23.687C47.3885 23.5375 43.8536 24.1171 40.5399 25.3907C37.2262 26.6642 34.2027 28.6052 31.6526 31.0959C29.1025 33.5867 27.079 36.5753 25.7047 39.8806C24.3304 43.186 23.6339 46.7392 23.6575 50.3249C23.6041 54.0347 24.3363 57.7131 25.8051 61.1128C27.2738 64.5125 29.445 67.5548 32.1727 70.0352C32.3916 70.2329 32.5688 70.4732 32.6938 70.7418C32.8188 71.0105 32.8888 71.3018 32.8999 71.5985V76.503C32.916 76.8585 33.0169 77.2048 33.1939 77.5123C33.3709 77.8199 33.6188 78.0796 33.9165 78.2692C34.2141 78.4589 34.5527 78.573 34.9033 78.6017C35.254 78.6304 35.6063 78.573 35.9302 78.4342L41.3241 76.0432C41.7843 75.8746 42.2883 75.8746 42.7484 76.0432C45.3137 76.7639 47.9648 77.1249 50.6272 77.1161C54.1625 77.2374 57.6858 76.6378 60.9873 75.3529C64.2887 74.0681 67.3008 72.1243 69.8441 69.6374C72.3874 67.1504 74.41 64.1711 75.7913 60.877C77.1726 57.5828 77.8845 54.0411 77.8845 50.4629C77.8845 46.8846 77.1726 43.3429 75.7913 40.0488C74.41 36.7546 72.3874 33.7754 69.8441 31.2884C67.3008 28.8014 64.2887 26.8577 60.9873 25.5728C57.6858 24.288 54.1625 23.6883 50.6272 23.8096L50.9302 23.687ZM67.2332 44.1636L59.3848 57.0074C59.0821 57.5108 58.6766 57.943 58.1955 58.2751C57.7143 58.6073 57.1686 58.8316 56.5948 58.9332C56.021 59.0348 55.4324 59.0112 54.8684 58.8641C54.3043 58.717 53.7779 58.4498 53.3242 58.0803L46.9908 53.2677C46.7033 53.0604 46.3591 52.949 46.006 52.949C45.6529 52.949 45.3086 53.0604 45.0211 53.2677L36.4757 59.8582C36.2323 60.0353 35.936 60.122 35.6368 60.1039C35.3375 60.0857 35.0536 59.9637 34.8329 59.7585C34.6122 59.5533 34.4682 59.2773 34.4252 58.9772C34.3822 58.677 34.4429 58.3711 34.5969 58.1109L42.5666 45.3284C42.8716 44.8479 43.273 44.4375 43.7448 44.1239C44.2166 43.8103 44.7483 43.6005 45.3054 43.508C45.8625 43.4155 46.4325 43.4424 46.9787 43.5871C47.5248 43.7317 48.0348 43.9908 48.4757 44.3475L54.8393 49.1601C55.1268 49.3674 55.4711 49.4788 55.8241 49.4788C56.1772 49.4788 56.5215 49.3674 56.809 49.1601L65.4454 42.447C65.6846 42.2954 65.9669 42.2287 66.2478 42.2572C66.5287 42.2857 66.7922 42.4078 66.997 42.6044C67.2017 42.801 67.336 43.0608 67.3788 43.3431C67.4216 43.6253 67.3704 43.914 67.2332 44.1636Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_17_283",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.9605 109.732) scale(121.212 122.614)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5697FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8936F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#DD537E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E06F62"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessanger);
export default __webpack_public_path__ + "static/media/Messanger.c80e8d9e2f7d5f49ffa29ba3e7a6b913.svg";
export { ForwardRef as ReactComponent };